import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '../../components/pages/Auth/LoginPage'

export const Route = createFileRoute('/_auth_not_required/signin')({
  component: () => <LoginPage isSignUp={false} />,
})
